import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { ExternalLink } from "components/common";
const GreyNoiseFullIPAdapterDocumentation = () => {
  const { t } = useTranslation("enterprise_integrations");
  const style = { marginBottom: 10 };
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("p", { style }, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "greynoise.documentation.description",
      components: {
        apiLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://docs.greynoise.io/" }),
        ipContextLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://docs.greynoise.io/reference/noisecontextip-1" }),
        riotLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://docs.greynoise.io/reference/riotip" })
      }
    }
  )));
};
export default GreyNoiseFullIPAdapterDocumentation;
